import { render } from "./MemberListOverlayFrivillig.vue?vue&type=template&id=a95b0246"
import script from "./MemberListOverlayFrivillig.vue?vue&type=script&lang=js"
export * from "./MemberListOverlayFrivillig.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__